import { EUserSystemRole } from '@/constants';
import { useUserStore } from '@/stores/user';

const isCurrentUserAdmin = () => useUserStore().user?.systemRole === EUserSystemRole.admin;

export default isCurrentUserAdmin;
